import React, { useState } from 'react';
import { Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48593004560603:1';
  const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48593012654299:1';
  return <section id="oferta" className="py-5 px-5 scroll-mt-10 bg-[#000000]" data-id="element-189">
      <div className="max-w-xl mx-auto" data-id="element-190">
        {/* Headline */}
        <div className="text-center mb-8" data-id="element-191">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-2" data-id="element-192">
            Elegí tu Mega Pack y comienza hoy:
          </h2>
          <p className="text-sm text-gray-400" data-id="element-193">
            Las dos opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        {/* Option 1 - Basic */}
        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-slate-900 rounded-xl p-5 mb-4 border-2 transition-all ${selected === 'basico' ? 'border-slate-500' : 'border-slate-800'}`} data-id="element-194">
          <div className="flex items-start justify-between gap-4" data-id="element-195">
            <div className="flex items-start gap-3" data-id="element-196">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'basico' ? 'border-white' : 'border-slate-600'}`} data-id="element-197">
                {selected === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-198" />}
              </div>
              <div data-id="element-199">
                <div className="flex items-center gap-2 mb-1" data-id="element-200">
                  <span className="text-base" data-id="element-201">📘</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-202">
                    MEGA PACK
                  </h4>
                </div>
                <p className="text-xs text-slate-500" data-id="element-203">
                  Cómo sanar la relación con tus padres
                </p>
                <p className="text-[10px] text-slate-600" data-id="element-204">6 tomos + 6 bonos</p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-205">
              <div className="text-xs text-slate-600 line-through" data-id="element-206">
                $27.990 ARS
              </div>
              <div className="text-2xl font-black text-white" data-id="element-207">$19.990</div>
            </div>
          </div>
        </button>

        {/* Option 2 - Highlighted */}
        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-slate-900 rounded-xl p-5 relative border-2 transition-all ${selected === 'completo' ? 'border-brand-yellow' : 'border-slate-800'}`} data-id="element-208">
          <div className="flex items-start justify-between gap-4" data-id="element-209">
            <div className="flex items-start gap-3" data-id="element-210">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'completo' ? 'border-brand-yellow' : 'border-slate-600'}`} data-id="element-211">
                {selected === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-brand-yellow" data-id="element-212" />}
              </div>
              <div data-id="element-213">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-214">
                  <span className="text-base" data-id="element-215">🏆</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-216">
                    MEGA PACK + SISTEMA DE CAMBIO FAMILIAR ⭐
                  </h4>
                </div>
                <div className="flex flex-wrap gap-2 mb-1" data-id="element-217">
                  <span className="bg-brand-yellow text-[10px] font-black px-2 py-0.5 rounded-md text-[#EEC15F]" data-id="element-218">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-600 text-white text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-219">
                    AHORRÁS $20.000
                  </span>
                </div>
                <p className="text-xs text-slate-400 leading-tight" data-id="element-220">
                  6 tomos + 6 bonos + Sistema completo
                </p>
                <p className="text-[10px] text-slate-500 mt-0.5 leading-tight" data-id="element-221">
                  (Sistema práctico para aplicar la sanación en la vida real)
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-222">
              <div className="text-xs text-slate-600 line-through" data-id="element-223">
                $49.990 ARS
              </div>
              <div className="text-2xl font-black text-white" data-id="element-224">$27.990 </div>
            </div>
          </div>
        </button>

        {/* CTA Button */}
        <a href={selected === 'completo' ? checkoutCompleto : checkoutBasico} className="block w-full hover:bg-brand-yellowHover text-black md:text-lg py-4 px-6 rounded-xl shadow-[0_4px_20px_0_rgba(251,191,36,0.4)] transition-all hover:scale-[1.02] text-center mt-8 mb-4 text-[14px] font-[900] bg-[#FBBE24]" data-id="element-225">
          {selected === 'completo' ? '👉 QUIERO EL MEGAPACK + SISTEMA' : '👉 QUIERO SANAR MI RELACIÓN'}
        </a>

        {/* Subtitle */}

        {/* Trust badges */}
        <div className="bg-slate-900 border border-slate-800 rounded-xl py-3 px-4" data-id="element-226">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-slate-400" data-id="element-227">
            <div className="flex items-center gap-1.5" data-id="element-228">
              <Lock size={13} className="text-brand-yellow" data-id="element-229" />
              Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-230">
              <Zap size={13} className="text-brand-yellow" data-id="element-231" />
              Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-232">
              <ShieldCheck size={13} className="text-brand-yellow" data-id="element-233" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-234">
              Paga en moneda local
            </div>
          </div>
          <div className="flex items-center justify-center gap-2 mt-2.5 pt-2.5 border-t border-slate-800" data-id="element-235">
            <CreditCard size={14} className="text-brand-yellow flex-shrink-0" data-id="element-236" />
            <span className="text-[11px] text-slate-400 font-medium text-center" data-id="element-237">
              Paga con tarjeta o MercadoPago de forma segura y accede al
              material HOY
            </span>
          </div>
        </div>
      </div>
    </section>;
}